import VueBaseController from '../../vue_base'

// eslint-disable-next-line import/prefer-default-export
export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/pr/order_automations/index.vue') }

  static values = {
    states: Array,
    canManage: Boolean,
    restrictedWords: Array
  }

  connect() {
    super.connect({
      states: this.statesValue,
      canManage: this.canManageValue,
      restrictedWords: this.restrictedWordsValue
    })
  }
}
